require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./checkbox"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./checkbox"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./checkbox")) : factory(root["./utils"], root["./checkbox"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__37__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[9],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(174);


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _CheckboxGroup = _interopRequireDefault(__webpack_require__(175));

exports["default"] = _CheckboxGroup["default"];
exports.CheckboxGroup = _CheckboxGroup["default"];

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _checkbox = _interopRequireDefault(__webpack_require__(37));

var _CheckboxGroup = _interopRequireDefault(__webpack_require__(176));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var checkboxGroupClassName = _CheckboxGroup["default"].checkboxGroupClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var CheckboxGroup = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(CheckboxGroup, _Component);

  function CheckboxGroup() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = CheckboxGroup.prototype;

  _proto._onChange = function _onChange(index) {
    this.props.onChange && this.props.onChange(this.props.options[index].label);
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        options = _this$props.options,
        align = _this$props.align,
        direction = _this$props.direction,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        hover = _this$props.hover,
        active = _this$props.active,
        visual = _this$props.visual,
        onClick = _this$props.onClick,
        selected = _this$props.selected,
        indeterminate = _this$props.indeterminate,
        className = _this$props.className,
        style = _this$props.style,
        checkboxsExtraOptions = _this$props.checkboxsExtraOptions,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["options", "align", "direction", "disabled", "readOnly", "hover", "active", "visual", "onClick", "selected", "indeterminate", "className", "style", "checkboxsExtraOptions"]);
    var classNames = (0, _utils.classnames)(checkboxGroupClassName, direction, align);
    var checkboxPassthroughProps = getInheritedProps(others, _checkbox["default"]);
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, CheckboxGroup), {
      className: classNames + " " + className,
      style: style
    }), options.map(function (_ref, index) {
      var label = _ref.label,
          title = _ref.title;
      var checkBoxProps = (0, _extends2["default"])({}, checkboxPassthroughProps, {
        label: label,
        checked: selected && selected[label] && !indeterminate,
        indeterminate: selected && selected[label] && indeterminate,
        title: title,
        align: align,
        disabled: disabled,
        readOnly: readOnly,
        visual: visual,
        hover: hover,
        active: active,
        onClick: onClick,
        onChange: _this._onChange.bind(_this, index),
        'aria-labelledby': label
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index,
        className: checkboxGroupClassName + "__item"
      }, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], (0, _extends2["default"])({}, checkBoxProps, {
        "data-tid": "ba-common-checkbox-group__checkbox-" + index
      })));
    }));
  };

  return CheckboxGroup;
}(_react.Component);

exports["default"] = CheckboxGroup;
(0, _defineProperty2["default"])(CheckboxGroup, "propTypes", (0, _extends2["default"])({}, _checkbox["default"].propTypes, {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string
  })).isRequired,
  selected: _propTypes["default"].object,
  indeterminate: _propTypes["default"].bool,
  tabIndex: _propTypes["default"].number,
  align: _propTypes["default"].oneOf(['left', 'right']),
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  hover: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  visual: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  onChange: _propTypes["default"].func.isRequired,
  direction: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}));
(0, _defineProperty2["default"])(CheckboxGroup, "defaultProps", {
  align: 'left',
  direction: 'vertical',
  className: '',
  style: {}
});

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(177);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-checkboxGroup{display:inline;max-width:100%}.ba-checkboxGroup__item{display:block}.ba-checkboxGroup.is-horizontal .ba-checkboxGroup__item{display:inline-block}.ba-checkboxGroup.is-horizontal.is-left .ba-checkboxGroup__item:not(:last-child){margin-right:8px}.ba-checkboxGroup.is-horizontal.is-right .ba-checkboxGroup__item:not(:first-child){margin-left:8px}[dir=\"rtl\"] .ba-checkboxGroup.is-right{text-align:left}[dir=\"ltr\"] .ba-checkboxGroup.is-right,.ba-checkboxGroup.is-right{text-align:right}\n", ""]);

// exports
exports.locals = {
	"checkboxGroupClassName": "\"ba-checkboxGroup\""
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__37__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[173,0]]]);
});